import { render, staticRenderFns } from "./baoJia.vue?vue&type=template&id=96b542ca&scoped=true&"
import script from "./baoJia.vue?vue&type=script&lang=js&"
export * from "./baoJia.vue?vue&type=script&lang=js&"
import style0 from "./baoJia.vue?vue&type=style&index=0&id=96b542ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b542ca",
  null
  
)

export default component.exports